import { FC } from 'react';
import { Agent } from 'src/types/agents.ts';
import { getDisplayAmount, shortenNumber } from 'src/utils/bigNumber.ts';

interface AgentInfoProps {
  agent: Agent;
}

export const AgentInfo: FC<AgentInfoProps> = ({ agent }) => {
  return (
    <div className="mb-3 flex flex-wrap items-center justify-center gap-6 rounded-3xl bg-[#191C1E] p-6 md:gap-8 md:p-8">
      <div className="flex flex-col items-center">
        <p className="text-sm text-gray-400">Type</p>
        {agent.origin.map((origin) => (
          <h2 key={origin} className="text-xl font-semibold text-white">
            {origin}
          </h2>
        ))}
      </div>
      <div className="flex flex-col items-center">
        <p className="text-sm text-gray-400">MCAP</p>
        <h2 className="text-xl font-semibold text-white">
          ${shortenNumber(agent.token_info?.market_cap_usd || 0)}
        </h2>
      </div>
      <div className="flex flex-col items-center">
        <p className="text-sm text-gray-400">Ticker</p>
        <h2 className="text-xl font-semibold text-white">${agent.ticker.toUpperCase()}</h2>
      </div>
      {/* <div className="flex flex-col items-center">
        <p className="text-sm text-gray-400">24H Vol</p>
        <h2 className="text-xl font-semibold text-white">
          ${shortenNumber(getDisplayAmount(agent.token_info?.volume_24 || 0))}
        </h2>
      </div> */}
      <div className="flex flex-col items-center">
        <p className="text-sm text-gray-400">Holders</p>
        <h2 className="text-xl font-semibold text-white">
          {shortenNumber(getDisplayAmount(agent.token_info?.holder_count || 0, { decimals: 0 }), 0)}
        </h2>
      </div>
      <div className="flex flex-col items-center">
        <p className="text-sm text-gray-400">Requests</p>
        <h2 className="text-xl font-semibold text-white">
          {shortenNumber(getDisplayAmount(agent.request_count || 0, { decimals: 0 }), 0)}
        </h2>
      </div>
      <div className="flex gap-1.5">
        {agent.twitter_agent_username && (
          <a href={`https://x.com/${agent.twitter_agent_username}`} target="_blank">
            <img src="/images/x-icon.svg" alt="X Icon" className="h-11 w-11 cursor-pointer" />
          </a>
        )}
        {agent.telegram_username && (
          <a href={`https://t.me/${agent.telegram_username}`} target="_blank">
            <img
              src="/images/tg-icon.svg"
              alt="Telegram Icon"
              className="h-11 w-11 cursor-pointer"
            />
          </a>
        )}
      </div>
    </div>
  );
};
